/**
 * A no-operation function that does nothing.
 * This is useful as a default callback or placeholder function.
 */
export function noop(): void {
  // no operation
}

export function debounce<T extends (...args: any[]) => any>(func: T, wait: number): T {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function (...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout)
    }

    timeout = setTimeout(() => {
      func(...args)
    }, wait)
  } as T
}
